










































import { Component, Mixins } from 'vue-property-decorator'
import { ITrackCount } from '@/store/modules/discovery'
import { toDateStringSafe } from '@/helpers/date'
import { HistoryViewMixin } from '@/mixins'
import { RecycleScroller } from 'vue-virtual-scroller'
import { combineArtistTitle } from '@/helpers/track'
import { EventBus, EventBusEvents } from '@/system/eventbus'

@Component({
  components: {
    Item: require('./Item').default,
    CopyTextModal: require('@/components/CopyTextModal').default,
    SpotifyPlaylistSaveModal: require('@/components/SpotifyPlaylistSaveModal').default,
    RecycleScroller,
    GlobalWaveformPlayer: require('@/components/GlobalWaveformPlayer').default
  }
})
export default class Results extends Mixins(HistoryViewMixin) {
  get results(): ITrackCount[] {
    return this.$store.state.discovery.results
  }

  get waveformItems(): { url: string, name: string }[] {
    return this.results.map(x => {
      return {
        url: x.track.previewUrl,
        name: combineArtistTitle(x.track.artist, x.track.title)
      }
    })
  }

  get spotifyTrackIds(): string[] {
    return this.results.map(x => x.track.id)
  }

  get copyFilename(): string {
    return `rekordcloud discovery ${toDateStringSafe(new Date())}`
  }

  get highestCount(): number {
    return Math.max(...this.results.map(x => x.count))
  }

  get selectedTracksOrAll(): any[] {
    if (this.$store.state.discovery.selectedIds.length === 0) {
      return this.results.map(x => x.track)
    } else {
      return this.results.filter(x => this.$store.state.discovery.selectedIds.includes(x.id)).map(x => x.track)
    }
  }

  get saveAmountLabel(): string {
    return this.$store.state.discovery.selectedIds.length === 0 ? 'all' : 'selected'
  }

  closePlayer() {
    EventBus.$emit(EventBusEvents.GlobalWaveformClose)
  }

  toggleResultSelected(index: number) {
    this.$store.commit('discovery/toggleSelectedByIndex', index)
  }

  getHotCount(result: ITrackCount): number {
    return Math.ceil(((result.count / this.highestCount) * 100) / 20)
  }

  openCopyModal() {
    (this.$refs.copyTextModal as any).openModal()
  }

  onPlaying(item: { index }) {
    if (item && item.hasOwnProperty('index')) {
      const scroller: any = (this.$refs as any).scroller

      if (scroller) {
        const track: ITrackCount = scroller.items[item.index]

        const el = scroller.pool.find(x => x.item.id === track.id)

        if (el) {
          const offsetTop: number = el.position
          const rowOffset: number = 64 * 1.5

          if (offsetTop > scroller.$el.clientHeight + scroller.$el.scrollTop - rowOffset) {
            scroller.$el.scrollTo({
              top: offsetTop - scroller.$el.clientHeight + rowOffset,
              left: 0,
              behavior: 'smooth'
            })
          } else if (offsetTop < scroller.$el.scrollTop) {
            scroller.$el.scrollTo({
              top: offsetTop,
              left: 0,
              behavior: 'smooth'
            })
          }
        }
      }
    }
  }

  async pipeToStoreLinks() {
    this.$store.commit('storelinks/setCombos', this.selectedTracksOrAll.map(x => [x.title, x.artist]))

    await this.$router.replace({
      name: 'store links input',
      query: {
        activeTab: '1'
      }
    })
  }

  async created() {
    if (!this.$store.getters['discovery/resultsAllowed']) {
      await this.$router.replace({
        name: 'discovery'
      })
    }

    EventBus.$on(EventBusEvents.GlobalWaveformPlay, this.onPlaying)
  }

  destroyed() {
    this.$store.commit('discovery/reset')

    EventBus.$off(EventBusEvents.GlobalWaveformPlay, this.onPlaying)
  }
}
